import { Backdrop, Button, Container, Paper } from "@mui/material";
import { Box, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import CustomHeader from "../../../core/components/common/custom-header.component";
import { useNavigate } from "react-router-dom";
import CustomButton from "../../../core/components/ui/CustomButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import CircularProgress from '@mui/material/CircularProgress';
import dayjs from "dayjs";
import UserService from "../service/api/user";
import CustomModal1 from "../../../core/components/ui/custom-modal1.component";
import SavePasswordDialogComponent from "../../OrganizationPlugin/components/save-password-dialog.component";
import { useUser } from "../hooks/useUser";
import { useSnackbar } from "notistack";

export default function UserUpdatePage() {

    const user_uid = new URLSearchParams(window.location.search).get("user_uid");

    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [email, setEmail] = useState('');
    const [birthdate, setBirthdate] = useState(null);
    const [middlename, setMiddleName] = useState("");
    const [contact_no, setContactNumber] = useState("");
    const [userErrors, setUserErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [progress, setProgress] = useState(0);
    const {enqueueSnackbar} = useSnackbar();

    const {loadingUser, viewUser, userDetails} = useUser();

    useEffect(() => {
        if (user_uid) {
            let paramters = {
                user_uid: user_uid
            };
            viewUser(paramters);
        }
    }, [user_uid]);
    

    const navigate = useNavigate();

    const handleBack = () => {
        navigate("/user")
    };



    const handleSubmit = async () => {
        let errors = {};

        if (!firstname.trim()) {
            errors.firstname = "First name is required";
        }
        if (!lastname.trim()) {
            errors.lastname = "Last name is required";
        }
        if (!contact_no.trim()) {
            errors.contact_no = "Contact number is required";
        }
        if (!birthdate) {
            errors.birthdate = "Birthdate is required";
        }

        setUserErrors(errors);

        if (Object.keys(errors).length > 0) {
            enqueueSnackbar("Please fill in all required fields", {
            variant: "error",
            autoHideDuration: 3000,
            });
            return; // 🚫 stop submission
        }

        setLoading(true);

        try {
            const userPayload = {
            firstname,
            middlename,
            lastname,
            contact_no,
            birthdate: dayjs(birthdate).format("YYYY-MM-DD"),
            user_uid,
            };

            await UserService.updateUser(userPayload);

            navigate(-1);
            enqueueSnackbar("User updated successfully!", { variant: "success" });
        } catch (error) {
            enqueueSnackbar("An error occurred while updating.", { variant: "error" });
        } finally {
            setLoading(false);
        }
        };


    useEffect(() => {
        if (userDetails?.user) {
            setFirstname(userDetails.user.firstname || "");
            setMiddleName(userDetails.user.middlename || "");
            setLastname(userDetails.user.lastname || "");
            setContactNumber(userDetails.user.contact_no || "");
            setBirthdate(userDetails.user.birthdate ? dayjs(userDetails.user.birthdate) : null);
        }
    }, [userDetails]);


     useEffect(() => {
        const interval = setInterval(() => {
            setProgress((oldProgress) => {
                if (oldProgress >= 100) {
                    clearInterval(interval);
                    setLoading(false);
                    return 100;
                }
                return Math.min(oldProgress + 10, 100);
            });
        }, 500);
        return () => clearInterval(interval);
    }, []);

    return (
        <>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1, }}
                open={loading}
            >
                <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
                    <CircularProgress
                        color="inherit"
                        value={progress} // Progress must be a value between 0 and 100
                        size={60}
                    />
                    <Typography mt={2} sx={{color:"#fff"}}>
                        Creating... 
                    </Typography>
                </Box>
                
            </Backdrop>
            <CustomButton
                variant="text" 
                startIcon={<ArrowBackIcon fontSize="small" />}
                label="Back to User Management"
                customStyles={{fontSize: 14, mt: 2}}
                onClick={handleBack}
            />
            <Container maxWidth="md">
                <Paper elevation={0} sx={{border: `1px solid #e5edf6`, borderRadius: 2, padding: "24px 32px", mt: 3}}>
                    <Box sx={{textAlign: "start", mb: 5}}>
                        <CustomHeader headerText={"Update User"} />
                    </Box>
                    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                        {/* <Typography sx={{fontWeight:'bold', mb: 2}}>User</Typography> */}
                        <TextField variant="standard" 
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }} label="First Name" fullWidth
                            value={firstname} 
                            onChange={(e) => setFirstname(e.target.value)}
                            error={!!userErrors.firstname}
                            helperText={userErrors.firstname}
                        />
                        <TextField label="Middle Name" variant="standard" 
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }} fullWidth
                            value={middlename} 
                            onChange={(e) => setMiddleName(e.target.value)}
                            error={!!userErrors.middlename}
                            helperText={userErrors.middlename}
                            placeholder={!userDetails?.user?.middlename && "Optional"}
                        />
                        <TextField label="Last Name" variant="standard" 
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }} fullWidth
                            value={lastname} 
                            onChange={(e) => setLastname(e.target.value)}
                            error={!!userErrors.lastname}
                            helperText={userErrors.lastname}
                        />

                      
                        <TextField label="Contact Number" variant="standard" 
                            slotProps={{
                                inputLabel: {
                                shrink: true
                                },
                            }} fullWidth
                            value={contact_no} 
                            onChange={(e) => setContactNumber(e.target.value)}
                            error={!!userErrors.contact_no}
                            helperText={userErrors.contact_no}
                        />
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DemoContainer components={['DatePicker']}>
                                <DatePicker label="Date of Birth" sx={{ width: '100%', overflow:'hidden'}} 
                                slotProps={{
                                    textField: {
                                        variant: 'standard',
                                        fullWidth: true,
                                        InputLabelProps: { shrink: true },
                                        error: !!userErrors.birthdate,
                                        helperText: userErrors.birthdate,
                                    },
                                }}
                                 value={userDetails?.user?.birthdate ? dayjs(userDetails?.user?.birthdate) : null}  onChange={setBirthdate} />
                            </DemoContainer>
                        </LocalizationProvider>
                        <Button type="button" variant="contained" sx={{ alignSelf: 'flex-end' }} onClick={handleSubmit}>
                            Update User
                        </Button>
                    </Box>
                </Paper>
            </Container>

           
        </>
    );
}
